import { useParams } from 'react-router-dom';
import { CourseViewer } from '../../components/CourseViewer';

// Course ID aliases - maps user-friendly URLs to actual course IDs in database
const COURSE_ALIASES: Record<string, string> = {
  'sample-alice-course': 'sample-stefan-course', // Alice course points to the same content
};

export function CoursePlayerPage() {
  const { courseId } = useParams<{ courseId: string }>();

  if (!courseId) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-600">No course ID provided</div>
      </div>
    );
  }

  // Resolve course ID alias to actual course ID
  const actualCourseId = COURSE_ALIASES[courseId] || courseId;

  return <CourseViewer courseId={actualCourseId} />;
}